<template>
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M9.65861 19C7.93008 14.2381 11.5824 12.4994 11.5824 12.4994C11.3269 15.0404 13.054 17.02 13.054 17.02C13.6893 16.8598 14.9017 16.1109 14.9017 16.1109C14.9017 17.02 14.262 18.9989 14.262 18.9989C14.262 18.9989 16.5016 17.5511 17.2066 15.1465C17.9107 12.7419 15.8655 10.3278 15.8655 10.3278C15.9887 12.0297 15.3 13.7036 13.9507 14.9825C14.0182 14.9173 14.0749 14.845 14.1183 14.7665C14.3608 14.3612 14.75 13.3078 14.522 10.8683C14.2013 7.44398 10.49 6 10.49 6C10.8099 8.08642 9.85072 8.56712 7.60385 12.5275C5.35699 16.487 9.65861 19 9.65861 19Z"
      fill="#738288" />
  </svg>
</template>

<script>
export default {}
</script>

<style scoped>

</style>
